import {
  Badge,
  Button,
  Icon,
  ImageFallback,
  Shadow,
  Text,
  VStack,
  HStack,
} from '@genial/components';
import { BoxRadius, Spacing, Typography, Color } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Pressable } from 'native-base';
import React from 'react';
import { useRecoilValue, useResetRecoilState } from 'recoil';

import { customerConsortiumPlanSelectedState } from '../../../../../../../../store/consortium/atom';

interface CategorySelectedProps {}

export const CategorySelected: React.FC<CategorySelectedProps> = () => {
  const customerConsortiumPlan = useRecoilValue(customerConsortiumPlanSelectedState);
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const resetCustomerConsortiumPlanSelected = useResetRecoilState(
    customerConsortiumPlanSelectedState
  );

  const handleResetCustomerConsortiumPlanSelected = () => {
    resetCustomerConsortiumPlanSelected();
  };

  if (isMobile) {
    return (
      <Shadow level={1} borderTopRadius={BoxRadius.sm} borderBottomRadius={BoxRadius.sm}>
        <VStack
          w="full"
          bg="neutral.white"
          space={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}>
          <VStack
            p={Spacing['stack.xxs']}
            borderBottomWidth="1px"
            borderBottomColor="neutral.light">
            <HStack alignItems="center" justifyContent="space-between">
              <Text
                fontSize={Typography['fontsize.lg']}
                variant="semibold"
                color="brand.primary.principal">
                Categoria selecionada
              </Text>
              <Badge
                testId="category-section-closed-badge"
                backgroundColor="feedback.success.default"
                textColor="neutral.white">
                Concluído
              </Badge>
            </HStack>
          </VStack>
          <VStack
            space={Spacing['inline.xxxs']}
            justifyContent="space-between"
            px={Spacing['inline.xxs']}
            pb={Spacing['inline.xxs']}>
            <HStack space={Spacing['inline.nano']} alignItems="center">
              <Icon
                name={customerConsortiumPlan?.categoryIcon as IconographyTypes.Option}
                size="sm"
                color={Color['brand.tertiary.principal']}
              />
              <Text variant="semibold" fontSize={Typography['fontsize.xl']} color="neutral.black">
                {customerConsortiumPlan?.itemName}
              </Text>
            </HStack>
            <HStack alignItems="center" space={Spacing['inline.quarck']}>
              <Text color="neutral.dark">Valor da simulação:</Text>
              <Text variant="semibold" color="neutral.darkest">
                {Utils.Mask.Money(customerConsortiumPlan?.creditValue)}
              </Text>
            </HStack>
            <HStack space={Spacing['inline.xxxs']}>
              <ImageFallback src="" alt="image-consortium" width="30px" height="30px" />
              <VStack space={Spacing['inline.quarck']} flex={1}>
                <Text>{customerConsortiumPlan?.company}</Text>
                <Text color="neutral.medium">Taxa de administração</Text>
              </VStack>
              <VStack space={Spacing['inline.quarck']} alignItems="flex-end">
                <HStack alignItems="center" space={Spacing['inline.quarck']}>
                  <Text color="neutral.medium">{customerConsortiumPlan?.installments} x</Text>
                  <Text variant="semibold" color="neutral.black">
                    {Utils.Mask.Money(customerConsortiumPlan?.installmentValue)}
                  </Text>
                </HStack>
                <Text color="neutral.medium">
                  {Utils.Mask.Percentage(customerConsortiumPlan?.adminFee)}
                </Text>
              </VStack>
            </HStack>
            <Pressable
              w="full"
              variant="textLink"
              onPress={handleResetCustomerConsortiumPlanSelected}>
              <HStack alignItems="center" justifyContent={'space-between'}>
                <Text variant="semibold" color="brand.tertiary.principal">
                  TROCAR CATEGORIA
                </Text>
                <Icon name="Reverse" size="xxs" color={Color['brand.tertiary.principal']} />
              </HStack>
            </Pressable>
          </VStack>
        </VStack>
      </Shadow>
    );
  }

  return (
    <Shadow level={1} borderTopRadius={BoxRadius.sm} borderBottomRadius={BoxRadius.sm}>
      <VStack w="full" bg="neutral.white" space={Spacing['inline.xxs']} borderRadius={BoxRadius.sm}>
        <VStack p={Spacing['stack.xxs']} borderBottomWidth="1px" borderBottomColor="neutral.light">
          <HStack alignItems="center" justifyContent="space-between">
            <Text
              fontSize={Typography['fontsize.lg']}
              variant="semibold"
              color="brand.primary.principal">
              Categoria selecionada
            </Text>
            <HStack space={Spacing['inline.xxxs']} alignItems="center">
              <Badge
                testId="category-section-closed-badge"
                backgroundColor="feedback.success.default"
                textColor="neutral.white">
                Concluído
              </Badge>
              <Button
                variant="textLink"
                onPress={handleResetCustomerConsortiumPlanSelected}
                _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}
                rightIcon={
                  <Icon name="Reverse" size="xxs" color={Color['brand.tertiary.principal']} />
                }>
                TROCAR CATEGORIA
              </Button>
            </HStack>
          </HStack>
        </VStack>
        <HStack p={Spacing['inline.xxs']} justifyContent="space-between">
          <VStack flex={1} space={Spacing['inline.nano']}>
            <HStack space={Spacing['inline.nano']} alignItems="center">
              <Icon
                name={customerConsortiumPlan?.categoryIcon as IconographyTypes.Option}
                size="sm"
                color={Color['brand.tertiary.principal']}
              />
              <Text variant="semibold" fontSize={Typography['fontsize.xl']} color="neutral.black">
                {customerConsortiumPlan?.itemName}
              </Text>
            </HStack>
            <HStack alignItems="center" space={Spacing['inline.quarck']}>
              <Text color="neutral.dark">Valor da simulação:</Text>
              <Text variant="semibold" color="neutral.darkest">
                {Utils.Mask.Money(customerConsortiumPlan?.creditValue)}
              </Text>
            </HStack>
          </VStack>
          <HStack space={Spacing['inline.xxxs']}>
            <ImageFallback src="" alt="image-consortium" width="30px" height="30px" />
            <VStack space={Spacing['inline.quarck']} flex={1}>
              <Text>{customerConsortiumPlan?.company}</Text>
              <Text color="neutral.medium">Taxa de administração</Text>
            </VStack>
            <VStack space={Spacing['inline.quarck']} alignItems="flex-end">
              <HStack alignItems="center" space={Spacing['inline.quarck']}>
                <Text color="neutral.medium">{customerConsortiumPlan?.installments} x</Text>
                <Text variant="semibold" color="neutral.black">
                  {Utils.Mask.Money(customerConsortiumPlan?.installmentValue)}
                </Text>
              </HStack>
              <Text color="neutral.medium">
                {Utils.Mask.Percentage(customerConsortiumPlan?.adminFee)}
              </Text>
            </VStack>
          </HStack>
        </HStack>
      </VStack>
    </Shadow>
  );
};
